module.exports = __webpack_public_path__ + "static/media/slack_logo.93afad6b.svg";